(function() {
  const searchInput = document.getElementById('recipe-search-input');
  const resultsContainer = document.getElementById('recipe-search-results');

  let allRecipes = [];
  
  async function loadAllRecipes() {
    resultsContainer.innerHTML = '<div class="loading">Loading recipes...</div>';

    try {
      let hasNextPage = true;
      let cursor = null;
      const recipes = [];

      while (hasNextPage) {
        const query = `
          {
            articles(first: 250${cursor ? `, after: "${cursor}"` : ''}, query: "blog_title:'Recipes'", sortKey: PUBLISHED_AT, reverse: true) {
              edges {
                node {
                  title
                  excerpt
                  tags
                  onlineStoreUrl
                  image {
                    url
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        `;

        const response = await fetch('/api/2026-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '44a704405786a0e7e714d0b0f376abb0'
          },
          body: JSON.stringify({ query })
        });

        const data = await response.json();

        if (data.errors) {
          console.error('GraphQL errors:', data.errors);
          throw new Error(data.errors[0].message);
        }

        if (!data.data || !data.data.articles) {
          console.error('Unexpected response:', data);
          throw new Error('Invalid response from API');
        }

        const articles = data.data.articles;

        articles.edges.forEach(edge => {
          recipes.push({
            title: edge.node.title,
            excerpt: edge.node.excerpt,
            tags: edge.node.tags,
            url: edge.node.onlineStoreUrl,
            image: edge.node.image
          });
        });

        hasNextPage = articles.pageInfo.hasNextPage;
        if (hasNextPage) {
          cursor = articles.pageInfo.endCursor;
        }
      }

      allRecipes = recipes;
      resultsContainer.innerHTML = '';
      console.log(`Loaded ${allRecipes.length} recipes`);
    } catch (error) {
      console.error('Error loading recipes:', error);
      resultsContainer.innerHTML = '<div class="error">Error loading recipes.</div>';
    }
  }

  function searchRecipes(query) {
    if (!query.trim()) {
      resultsContainer.innerHTML = '';
      return;
    }

    const searchTerm = query.toLowerCase();
    const filtered = allRecipes.filter(recipe => {
      const titleMatch = recipe.title.toLowerCase().includes(searchTerm);
      const tagMatch = recipe.tags && recipe.tags.some(tag =>
        tag.toLowerCase().includes(searchTerm)
      );
      return titleMatch || tagMatch;
    });

    displayResults(filtered.slice(0, 10));
  }

  function displayResults(articles) {
    if (!articles || articles.length === 0) {
      resultsContainer.innerHTML = '<div class="no-results">No recipes found.</div>';
      return;
    }

    resultsContainer.innerHTML = articles.map(article => {
      const imageUrl = article.image?.url || '';
      const altText = article.image?.altText || article.title;
      
      return `
        <div class="recipe-item">
          ${imageUrl ? `<img src="${imageUrl}" alt="${altText}" class="recipe-thumb">` : '<div class="recipe-thumb-placeholder"></div>'}
          <a href="${article.url}" class="recipe-link">${article.title}</a>
        </div>
      `;
    }).join('');
  }

  searchInput.addEventListener('input', function(e) {
    searchRecipes(e.target.value);
  });
  
  loadAllRecipes();
})();
